import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Skeleton from "components/ui/Skeleton";
import NoDataState from "modules/swiftboard/components/NoDataState";
import { CAMPAIGN_STATUS_STYLE, CAMPAIGN_STATUS_LABEL } from "../../campaigns/features/campaign.constants";
import { CATEGORY_META, fmtCompact, fmtDateTime } from "../utils";

const RecentCampaigns = ({ campaigns, loading }) => {
  return (
    <div className="lg:col-span-2 rounded-2xl border border-border bg-surface overflow-hidden">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div>
          <h2 className="font-semibold text-text_primary">Recent Campaigns</h2>
          <p className="text-xs text-text_muted mt-0.5">Latest activity in the selected period</p>
        </div>
        <Link to="/swiftboard/email-management/campaigns" className="text-xs font-medium text-primary flex items-center gap-1 hover:underline">
          View all <ArrowUpRight size={12} />
        </Link>
      </div>

      {loading ? (
        <div className="p-5"><Skeleton.Rows rows={5} /></div>
      ) : !campaigns?.length ? (
        <NoDataState
          icon="folder-open"
          title="No campaigns yet"
          message="No campaign activity in the selected period."
          size="small"
          showBack={false}
          showRefresh={false}
        />
      ) : (
        <div className="divide-y divide-border">
          {campaigns.map((c) => {
            const statusStyle = CAMPAIGN_STATUS_STYLE[c.status] || CAMPAIGN_STATUS_STYLE.DRAFT;
            const categoryMeta = CATEGORY_META[c.category];
            return (
              <div key={c.id} className="px-5 py-3.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`text-[11px] font-medium px-2 py-0.5 rounded-md border ${statusStyle.bg} ${statusStyle.text} ${statusStyle.border}`}>
                      {CAMPAIGN_STATUS_LABEL[c.status] || c.status}
                    </span>
                    {categoryMeta && <span className="text-[11px] text-text_muted">{categoryMeta.label}</span>}
                  </div>
                  <p className="text-sm font-medium text-text_primary truncate">{c.campaign_name || c.subject}</p>
                  <p className="text-xs text-text_muted mt-0.5">
                    {c.sent_date ? `Sent ${fmtDateTime(c.sent_date)}` : c.scheduled_date ? `Scheduled ${fmtDateTime(c.scheduled_date)}` : "Not scheduled"}
                  </p>
                </div>
                <div className="flex items-center gap-5 text-center flex-shrink-0">
                  <div>
                    <p className="text-xs text-text_muted mb-0.5">Sent</p>
                    <p className="text-sm font-semibold text-text_primary tabular-nums">{fmtCompact(c.total_sent)}</p>
                  </div>
                  <div>
                    <p className="text-xs text-text_muted mb-0.5">Open Rate</p>
                    <p className="text-sm font-semibold text-text_primary tabular-nums">{c.open_rate}%</p>
                  </div>
                  <div>
                    <p className="text-xs text-text_muted mb-0.5">CTR</p>
                    <p className="text-sm font-semibold text-text_primary tabular-nums">{c.click_rate}%</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RecentCampaigns;
